require('vendor/modernizr');
require('angular-ui-router');
require('angular-resource');
require('angular-sanitize');
require('angular-cookies');
module.exports = require('angular').module('app', ['am', 'ui.router', 'ngSanitize', 'ngResource', 'ngCookies']);



/** WEBPACK FOOTER **
 ** ../AccountApp/external.js
 **/